export enum AppResourceType {
	PRODUCT = "PRODUCT",
	CONTACT = "CONTACT",
	PRODUCT_CATEGORY = "PRODUCT_CATEGORY",
	STOCK = "STOCK",
}

export enum AppModalViewMode {
	EMPTY = "EMPTY",
	DESCRIPTION = "DESCRIPTION",
	START = "START",
	FORM = "FORM",
	LOGS = "LOGS",
}

export enum Providers {
	LOCATIONS = "LOCATIONS",
	GOPOS_V2 = "GOPOS_V2",
	GOPOS = "GOPOS",
	DOCUMENT_TRANSFER = "DOCUMENT_TRANSFER",
	GASTROSUPPLIER = "GASTROSUPPLIER",
	GASTROSUPPLIER_MERCHANT = "GASTROSUPPLIER_MERCHANT",
	DOCUMENT_FILE_IMPORT = "DOCUMENT_FILE_IMPORT",
}

export enum AppActionType {
	ENABLE = "ENABLE",
	RESET = "RESET",
	DEACTIVATE = "DEACTIVATE",
}
